var map = {
	"./views/configuration/fiscal-spans/fiscal-period-updates.module": [
		"./src/app/views/configuration/fiscal-spans/fiscal-period-updates.module.ts",
		"views-configuration-fiscal-spans-fiscal-period-updates-module~views-ecommerce-configuration-configur~0f61ff06",
		"common",
		"views-configuration-fiscal-spans-fiscal-period-updates-module"
	],
	"./views/configuration/management/management.module": [
		"./src/app/views/configuration/management/management.module.ts",
		"views-configuration-management-management-module"
	],
	"./views/configuration/security/security-module.module": [
		"./src/app/views/configuration/security/security-module.module.ts",
		"views-configuration-security-security-module-module~views-ecommerce-configuration-configuration-modu~46da6508",
		"common",
		"views-configuration-security-security-module-module"
	],
	"./views/configuration/tax-setup/tax-setups.module": [
		"./src/app/views/configuration/tax-setup/tax-setups.module.ts",
		"views-configuration-tax-setup-tax-setups-module"
	],
	"./views/dashboard/dashboard.module": [
		"./src/app/views/dashboard/dashboard.module.ts",
		"views-dashboard-dashboard-module~views-finance-Reports-summary-summary-reports-module~views-finance-~cfa48eec",
		"common",
		"views-dashboard-dashboard-module"
	],
	"./views/ecommerce/buyer-management/buyer-management.module": [
		"./src/app/views/ecommerce/buyer-management/buyer-management.module.ts",
		"views-ecommerce-buyer-management-buyer-management-module"
	],
	"./views/ecommerce/catalog-management/catalog-management.module": [
		"./src/app/views/ecommerce/catalog-management/catalog-management.module.ts",
		"views-ecommerce-catalog-management-catalog-management-module~views-ecommerce-configuration-configura~d79f83f2",
		"views-ecommerce-catalog-management-catalog-management-module~views-ecommerce-promotions-promotions-m~af66c750",
		"common",
		"views-ecommerce-catalog-management-catalog-management-module"
	],
	"./views/ecommerce/configuration/configuration.module": [
		"./src/app/views/ecommerce/configuration/configuration.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"views-configuration-security-security-module-module~views-ecommerce-configuration-configuration-modu~46da6508",
		"views-configuration-fiscal-spans-fiscal-period-updates-module~views-ecommerce-configuration-configur~0f61ff06",
		"views-ecommerce-catalog-management-catalog-management-module~views-ecommerce-configuration-configura~d79f83f2",
		"common",
		"views-ecommerce-configuration-configuration-module"
	],
	"./views/ecommerce/content-management/content-management.module": [
		"./src/app/views/ecommerce/content-management/content-management.module.ts",
		"views-ecommerce-content-management-content-management-module"
	],
	"./views/ecommerce/coupon-management/coupon-management.module": [
		"./src/app/views/ecommerce/coupon-management/coupon-management.module.ts",
		"views-ecommerce-coupon-management-coupon-management-module"
	],
	"./views/ecommerce/delivery-management/delivery-management.module": [
		"./src/app/views/ecommerce/delivery-management/delivery-management.module.ts",
		"views-configuration-security-security-module-module~views-ecommerce-configuration-configuration-modu~46da6508",
		"views-ecommerce-catalog-management-catalog-management-module~views-ecommerce-configuration-configura~d79f83f2",
		"common",
		"views-ecommerce-delivery-management-delivery-management-module"
	],
	"./views/ecommerce/discount-management/discount-management.module": [
		"./src/app/views/ecommerce/discount-management/discount-management.module.ts",
		"views-ecommerce-discount-management-discount-management-module"
	],
	"./views/ecommerce/orders/orders.module": [
		"./src/app/views/ecommerce/orders/orders.module.ts",
		"views-ecommerce-catalog-management-catalog-management-module~views-ecommerce-configuration-configura~d79f83f2",
		"common",
		"views-ecommerce-orders-orders-module"
	],
	"./views/ecommerce/promotions/promotions.module": [
		"./src/app/views/ecommerce/promotions/promotions.module.ts",
		"views-configuration-security-security-module-module~views-ecommerce-configuration-configuration-modu~46da6508",
		"views-ecommerce-catalog-management-catalog-management-module~views-ecommerce-configuration-configura~d79f83f2",
		"views-ecommerce-catalog-management-catalog-management-module~views-ecommerce-promotions-promotions-m~af66c750",
		"common",
		"views-ecommerce-promotions-promotions-module"
	],
	"./views/ecommerce/setting/setting.module": [
		"./src/app/views/ecommerce/setting/setting.module.ts",
		"views-ecommerce-setting-setting-module"
	],
	"./views/finance/Reports/Ledgers&Statements/generic-statements.module": [
		"./src/app/views/finance/Reports/Ledgers&Statements/generic-statements.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"views-configuration-security-security-module-module~views-ecommerce-configuration-configuration-modu~46da6508",
		"common",
		"views-finance-Reports-Ledgers-Statements-generic-statements-module"
	],
	"./views/finance/Reports/analytic-group/analytic-group.module": [
		"./src/app/views/finance/Reports/analytic-group/analytic-group.module.ts",
		"views-configuration-security-security-module-module~views-ecommerce-configuration-configuration-modu~46da6508",
		"common",
		"views-finance-Reports-analytic-group-analytic-group-module"
	],
	"./views/finance/Reports/listings/audit-reports.module": [
		"./src/app/views/finance/Reports/listings/audit-reports.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"views-configuration-security-security-module-module~views-ecommerce-configuration-configuration-modu~46da6508",
		"common",
		"views-finance-Reports-listings-audit-reports-module"
	],
	"./views/finance/Reports/summary/summary-reports.module": [
		"./src/app/views/finance/Reports/summary/summary-reports.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"views-configuration-security-security-module-module~views-ecommerce-configuration-configuration-modu~46da6508",
		"views-dashboard-dashboard-module~views-finance-Reports-summary-summary-reports-module~views-finance-~cfa48eec",
		"common",
		"views-finance-Reports-summary-summary-reports-module"
	],
	"./views/finance/accounts/accounts.module": [
		"./src/app/views/finance/accounts/accounts.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"views-configuration-security-security-module-module~views-ecommerce-configuration-configuration-modu~46da6508",
		"views-finance-accounts-accounts-module~views-procurement-business-partners-business-partners-module~~26e5ccbb",
		"common",
		"views-finance-accounts-accounts-module"
	],
	"./views/finance/banking/banking.module": [
		"./src/app/views/finance/banking/banking.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"common",
		"views-finance-banking-banking-module"
	],
	"./views/finance/cheques/incoming-cheques.module": [
		"./src/app/views/finance/cheques/incoming-cheques.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"common",
		"views-finance-cheques-incoming-cheques-module"
	],
	"./views/finance/earnings/earnings.module": [
		"./src/app/views/finance/earnings/earnings.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"common",
		"views-finance-earnings-earnings-module"
	],
	"./views/finance/expenses/expenses.module": [
		"./src/app/views/finance/expenses/expenses.module.ts",
		"common",
		"views-finance-expenses-expenses-module"
	],
	"./views/finance/finance-setup/finance-setup.module": [
		"./src/app/views/finance/finance-setup/finance-setup.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"common",
		"views-finance-finance-setup-finance-setup-module"
	],
	"./views/finance/invoicing/invoicing.module": [
		"./src/app/views/finance/invoicing/invoicing.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"views-finance-invoicing-invoicing-module~views-finance-notes-notes-module~views-reportprint-report-p~efc2f562",
		"common",
		"views-finance-invoicing-invoicing-module"
	],
	"./views/finance/notes/notes.module": [
		"./src/app/views/finance/notes/notes.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"views-finance-invoicing-invoicing-module~views-finance-notes-notes-module~views-reportprint-report-p~efc2f562",
		"common",
		"views-finance-notes-notes-module"
	],
	"./views/finance/payments/payments.module": [
		"./src/app/views/finance/payments/payments.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"common",
		"views-finance-payments-payments-module"
	],
	"./views/finance/transactions/transactions.module": [
		"./src/app/views/finance/transactions/transactions.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"views-dashboard-dashboard-module~views-finance-Reports-summary-summary-reports-module~views-finance-~cfa48eec",
		"common",
		"views-finance-transactions-transactions-module"
	],
	"./views/pos/order-management/order-management.module": [
		"./src/app/views/pos/order-management/order-management.module.ts",
		"views-pos-order-management-order-management-module"
	],
	"./views/pos/point-of-sales-setups/point-of-sales-setups.module": [
		"./src/app/views/pos/point-of-sales-setups/point-of-sales-setups.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"views-configuration-security-security-module-module~views-ecommerce-configuration-configuration-modu~46da6508",
		"common",
		"views-pos-point-of-sales-setups-point-of-sales-setups-module"
	],
	"./views/pos/pos.module": [
		"./src/app/views/pos/pos.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"common",
		"views-pos-pos-module"
	],
	"./views/procurement/Reports/acquisition/acquisition.module": [
		"./src/app/views/procurement/Reports/acquisition/acquisition.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"views-configuration-security-security-module-module~views-ecommerce-configuration-configuration-modu~46da6508",
		"common",
		"views-procurement-Reports-acquisition-acquisition-module"
	],
	"./views/procurement/Reports/invoices-reports/invoices-reports.module": [
		"./src/app/views/procurement/Reports/invoices-reports/invoices-reports.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"views-configuration-security-security-module-module~views-ecommerce-configuration-configuration-modu~46da6508",
		"common",
		"views-procurement-Reports-invoices-reports-invoices-reports-module"
	],
	"./views/procurement/Reports/order-reports/order-reports.module": [
		"./src/app/views/procurement/Reports/order-reports/order-reports.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"views-configuration-security-security-module-module~views-ecommerce-configuration-configuration-modu~46da6508",
		"common",
		"views-procurement-Reports-order-reports-order-reports-module"
	],
	"./views/procurement/Reports/payments-reports/payments-reports.module": [
		"./src/app/views/procurement/Reports/payments-reports/payments-reports.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"views-configuration-security-security-module-module~views-ecommerce-configuration-configuration-modu~46da6508",
		"common",
		"views-procurement-Reports-payments-reports-payments-reports-module"
	],
	"./views/procurement/Reports/procurment-reports/procurment-reports.module": [
		"./src/app/views/procurement/Reports/procurment-reports/procurment-reports.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"views-configuration-security-security-module-module~views-ecommerce-configuration-configuration-modu~46da6508",
		"common",
		"views-procurement-Reports-procurment-reports-procurment-reports-module"
	],
	"./views/procurement/Reports/sales-reports/sales-reports.module": [
		"./src/app/views/procurement/Reports/sales-reports/sales-reports.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"views-configuration-security-security-module-module~views-ecommerce-configuration-configuration-modu~46da6508",
		"common",
		"views-procurement-Reports-sales-reports-sales-reports-module"
	],
	"./views/procurement/Reports/stocks-reports/stocks-reports.module": [
		"./src/app/views/procurement/Reports/stocks-reports/stocks-reports.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"views-configuration-security-security-module-module~views-ecommerce-configuration-configuration-modu~46da6508",
		"common",
		"views-procurement-Reports-stocks-reports-stocks-reports-module"
	],
	"./views/procurement/Reports/tax-reports/tax-reports.module": [
		"./src/app/views/procurement/Reports/tax-reports/tax-reports.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"views-configuration-security-security-module-module~views-ecommerce-configuration-configuration-modu~46da6508",
		"common",
		"views-procurement-Reports-tax-reports-tax-reports-module"
	],
	"./views/procurement/banking/banking.module": [
		"./src/app/views/procurement/banking/banking.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"common",
		"views-procurement-banking-banking-module"
	],
	"./views/procurement/barcode/barcode.module": [
		"./src/app/views/procurement/barcode/barcode.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"common",
		"views-procurement-barcode-barcode-module"
	],
	"./views/procurement/business-partners/business-partners.module": [
		"./src/app/views/procurement/business-partners/business-partners.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"views-finance-accounts-accounts-module~views-procurement-business-partners-business-partners-module~~26e5ccbb",
		"common",
		"views-procurement-business-partners-business-partners-module"
	],
	"./views/procurement/loyalty/loyalty.module": [
		"./src/app/views/procurement/loyalty/loyalty.module.ts",
		"views-configuration-security-security-module-module~views-ecommerce-configuration-configuration-modu~46da6508",
		"common",
		"views-procurement-loyalty-loyalty-module"
	],
	"./views/procurement/master/master.module": [
		"./src/app/views/procurement/master/master.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"common",
		"views-procurement-master-master-module"
	],
	"./views/procurement/offere-discount/offere-discount.module": [
		"./src/app/views/procurement/offere-discount/offere-discount.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"common",
		"views-procurement-offere-discount-offere-discount-module"
	],
	"./views/procurement/partner-directory/partner-directory.module": [
		"./src/app/views/procurement/partner-directory/partner-directory.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"views-dashboard-dashboard-module~views-finance-Reports-summary-summary-reports-module~views-finance-~cfa48eec",
		"common",
		"views-procurement-partner-directory-partner-directory-module"
	],
	"./views/procurement/purchase/purchase.module": [
		"./src/app/views/procurement/purchase/purchase.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"views-configuration-fiscal-spans-fiscal-period-updates-module~views-ecommerce-configuration-configur~0f61ff06",
		"common",
		"views-procurement-purchase-purchase-module"
	],
	"./views/procurement/sales/sales.module": [
		"./src/app/views/procurement/sales/sales.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"views-configuration-security-security-module-module~views-ecommerce-configuration-configuration-modu~46da6508",
		"views-configuration-fiscal-spans-fiscal-period-updates-module~views-ecommerce-configuration-configur~0f61ff06",
		"common",
		"views-procurement-sales-sales-module"
	],
	"./views/procurement/setup/procurement-setup.module": [
		"./src/app/views/procurement/setup/procurement-setup.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"views-configuration-security-security-module-module~views-ecommerce-configuration-configuration-modu~46da6508",
		"views-configuration-fiscal-spans-fiscal-period-updates-module~views-ecommerce-configuration-configur~0f61ff06",
		"common",
		"views-procurement-setup-procurement-setup-module"
	],
	"./views/procurement/stock-pile-management/stock-pile-management.module": [
		"./src/app/views/procurement/stock-pile-management/stock-pile-management.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"views-configuration-security-security-module-module~views-ecommerce-configuration-configuration-modu~46da6508",
		"views-finance-accounts-accounts-module~views-procurement-business-partners-business-partners-module~~26e5ccbb",
		"common",
		"views-procurement-stock-pile-management-stock-pile-management-module"
	],
	"./views/reportprint/report-print.module": [
		"./src/app/views/reportprint/report-print.module.ts",
		"views-finance-invoicing-invoicing-module~views-finance-notes-notes-module~views-reportprint-report-p~efc2f562",
		"views-reportprint-report-print-module~views-restaurant-catalog-management-catalog-management-module~~7c64928d",
		"common",
		"views-reportprint-report-print-module"
	],
	"./views/restaurant/catalog-management/catalog-management.module": [
		"./src/app/views/restaurant/catalog-management/catalog-management.module.ts",
		"views-configuration-security-security-module-module~views-ecommerce-configuration-configuration-modu~46da6508",
		"views-ecommerce-catalog-management-catalog-management-module~views-ecommerce-promotions-promotions-m~af66c750",
		"views-reportprint-report-print-module~views-restaurant-catalog-management-catalog-management-module~~7c64928d",
		"common",
		"views-restaurant-catalog-management-catalog-management-module"
	],
	"./views/restaurant/core/core.module": [
		"./src/app/views/restaurant/core/core.module.ts",
		"views-configuration-security-security-module-module~views-ecommerce-configuration-configuration-modu~46da6508",
		"views-reportprint-report-print-module~views-restaurant-catalog-management-catalog-management-module~~7c64928d",
		"common",
		"views-restaurant-core-core-module"
	],
	"./views/restaurant/order-management/order-management.module": [
		"./src/app/views/restaurant/order-management/order-management.module.ts",
		"views-configuration-security-security-module-module~views-ecommerce-configuration-configuration-modu~46da6508",
		"common",
		"views-restaurant-order-management-order-management-module"
	],
	"./views/restaurant/setting/setting.module": [
		"./src/app/views/restaurant/setting/setting.module.ts",
		"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3",
		"views-configuration-security-security-module-module~views-ecommerce-configuration-configuration-modu~46da6508",
		"common",
		"views-restaurant-setting-setting-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;